module.exports = __webpack_public_path__ + "img/prevewmore.9efbed21.svg";